var items = {
  "block.minecraft.air": "powietrze",
  "block.minecraft.stone": "kamień",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "wypolerowany granit",
  "block.minecraft.diorite": "dioryt",
  "block.minecraft.polished_diorite": "wypolerowany dioryt",
  "block.minecraft.andesite": "andezyt",
  "block.minecraft.polished_andesite": "wypolerowany andezyt",
  "block.minecraft.grass_block": "blok trawy",
  "block.minecraft.dirt": "ziemia",
  "block.minecraft.coarse_dirt": "twarda ziemia",
  "block.minecraft.podzol": "bielica",
  "block.minecraft.crimson_nylium": "szkarłatne nylium",
  "block.minecraft.warped_nylium": "spaczone nylium",
  "block.minecraft.cobblestone": "bruk",
  "block.minecraft.oak_planks": "dębowe deski",
  "block.minecraft.spruce_planks": "świerkowe deski",
  "block.minecraft.birch_planks": "brzozowe deski",
  "block.minecraft.jungle_planks": "tropikalne deski",
  "block.minecraft.acacia_planks": "akacjowe deski",
  "block.minecraft.dark_oak_planks": "ciemnodębowe deski",
  "block.minecraft.crimson_planks": "szkarłatne deski",
  "block.minecraft.warped_planks": "spaczone deski",
  "block.minecraft.oak_sapling": "sadzonka dębu",
  "block.minecraft.spruce_sapling": "sadzonka świerku",
  "block.minecraft.birch_sapling": "sadzonka brzozy",
  "block.minecraft.jungle_sapling": "sadzonka tropikalna",
  "block.minecraft.acacia_sapling": "sadzonka akacji",
  "block.minecraft.dark_oak_sapling": "sadzonka ciemnego dębu",
  "block.minecraft.bedrock": "skała macierzysta",
  "block.minecraft.sand": "piasek",
  "block.minecraft.red_sand": "czerwony piasek",
  "block.minecraft.gravel": "żwir",
  "block.minecraft.gold_ore": "złoże złota",
  "block.minecraft.iron_ore": "złoże żelaza",
  "block.minecraft.coal_ore": "złoże węgla",
  "block.minecraft.nether_gold_ore": "netherowe złoże złota",
  "block.minecraft.oak_log": "dębowy pień",
  "block.minecraft.spruce_log": "świerkowy pień",
  "block.minecraft.birch_log": "brzozowy pień",
  "block.minecraft.jungle_log": "tropikalny pień",
  "block.minecraft.acacia_log": "akacjowy pień",
  "block.minecraft.dark_oak_log": "ciemnodębowy pień",
  "block.minecraft.crimson_stem": "szkarłatny trzon",
  "block.minecraft.warped_stem": "spaczony trzon",
  "block.minecraft.stripped_oak_log": "okorowany dębowy pień",
  "block.minecraft.stripped_spruce_log": "okorowany świerkowy pień",
  "block.minecraft.stripped_birch_log": "okorowany brzozowy pień",
  "block.minecraft.stripped_jungle_log": "okorowany tropikalny pień",
  "block.minecraft.stripped_acacia_log": "okorowany akacjowy pień",
  "block.minecraft.stripped_dark_oak_log": "okorowany ciemnodębowy pień",
  "block.minecraft.stripped_crimson_stem": "ociosany szkarłatny trzon",
  "block.minecraft.stripped_warped_stem": "ociosany spaczony trzon",
  "block.minecraft.stripped_oak_wood": "okorowane dębowe drewno",
  "block.minecraft.stripped_spruce_wood": "okorowane świerkowe drewno",
  "block.minecraft.stripped_birch_wood": "okorowane brzozowe drewno",
  "block.minecraft.stripped_jungle_wood": "okorowane tropikalne drewno",
  "block.minecraft.stripped_acacia_wood": "okorowane akacjowe drewno",
  "block.minecraft.stripped_dark_oak_wood": "okorowane ciemnodębowe drewno",
  "block.minecraft.stripped_crimson_hyphae": "ociosane szkarłatne strzępki",
  "block.minecraft.stripped_warped_hyphae": "ociosane spaczone strzępki",
  "block.minecraft.oak_wood": "dębowe drewno",
  "block.minecraft.spruce_wood": "świerkowe drewno",
  "block.minecraft.birch_wood": "brzozowe drewno",
  "block.minecraft.jungle_wood": "tropikalne drewno",
  "block.minecraft.acacia_wood": "akacjowe drewno",
  "block.minecraft.dark_oak_wood": "ciemnodębowe drewno",
  "block.minecraft.crimson_hyphae": "szkarłatne strzępki",
  "block.minecraft.warped_hyphae": "spaczone strzępki",
  "block.minecraft.oak_leaves": "dębowe liście",
  "block.minecraft.spruce_leaves": "świerkowe liście",
  "block.minecraft.birch_leaves": "brzozowe liście",
  "block.minecraft.jungle_leaves": "tropikalne liście",
  "block.minecraft.acacia_leaves": "akacjowe liście",
  "block.minecraft.dark_oak_leaves": "ciemnodębowe liście",
  "block.minecraft.sponge": "gąbka",
  "block.minecraft.wet_sponge": "mokra gąbka",
  "block.minecraft.glass": "szkło",
  "block.minecraft.lapis_ore": "złoże lazurytu",
  "block.minecraft.lapis_block": "blok lazurytu",
  "block.minecraft.dispenser": "dozownik",
  "block.minecraft.sandstone": "piaskowiec",
  "block.minecraft.chiseled_sandstone": "rzeźbiony piaskowiec",
  "block.minecraft.cut_sandstone": "przycięty piaskowiec",
  "block.minecraft.note_block": "blok dźwiękowy",
  "block.minecraft.powered_rail": "zasilane tory",
  "block.minecraft.detector_rail": "tory z czujnikiem",
  "block.minecraft.sticky_piston": "lepki tłok",
  "block.minecraft.cobweb": "pajęczyna",
  "block.minecraft.grass": "trawa",
  "block.minecraft.fern": "paproć",
  "block.minecraft.dead_bush": "uschnięty krzak",
  "block.minecraft.seagrass": "trawa morska",
  "block.minecraft.sea_pickle": "iskrzyłuda",
  "block.minecraft.piston": "tłok",
  "block.minecraft.white_wool": "biała wełna",
  "block.minecraft.orange_wool": "pomarańczowa wełna",
  "block.minecraft.magenta_wool": "karmazynowa wełna",
  "block.minecraft.light_blue_wool": "jasnoniebieska wełna",
  "block.minecraft.yellow_wool": "żółta wełna",
  "block.minecraft.lime_wool": "jasnozielona wełna",
  "block.minecraft.pink_wool": "różowa wełna",
  "block.minecraft.gray_wool": "szara wełna",
  "block.minecraft.light_gray_wool": "jasnoszara wełna",
  "block.minecraft.cyan_wool": "błękitna wełna",
  "block.minecraft.purple_wool": "fioletowa wełna",
  "block.minecraft.blue_wool": "niebieska wełna",
  "block.minecraft.brown_wool": "brązowa wełna",
  "block.minecraft.green_wool": "zielona wełna",
  "block.minecraft.red_wool": "czerwona wełna",
  "block.minecraft.black_wool": "czarna wełna",
  "block.minecraft.dandelion": "mlecz",
  "block.minecraft.poppy": "mak",
  "block.minecraft.blue_orchid": "niebieska orchidea",
  "block.minecraft.allium": "czosnek",
  "block.minecraft.azure_bluet": "houstonia błękitna",
  "block.minecraft.red_tulip": "czerwony tulipan",
  "block.minecraft.orange_tulip": "pomarańczowy tulipan",
  "block.minecraft.white_tulip": "biały tulipan",
  "block.minecraft.pink_tulip": "różowy tulipan",
  "block.minecraft.oxeye_daisy": "margaretka",
  "block.minecraft.cornflower": "chaber",
  "block.minecraft.lily_of_the_valley": "konwalia",
  "block.minecraft.wither_rose": "witherowa róża",
  "block.minecraft.brown_mushroom": "borowik",
  "block.minecraft.red_mushroom": "muchomor",
  "block.minecraft.crimson_fungus": "szkarłatny grzyb",
  "block.minecraft.warped_fungus": "spaczony grzyb",
  "block.minecraft.crimson_roots": "szkarłatne korzenie",
  "block.minecraft.warped_roots": "spaczone korzenie",
  "block.minecraft.nether_sprouts": "netherowe kiełki",
  "block.minecraft.weeping_vines": "płaczące pnącza",
  "block.minecraft.twisting_vines": "spaczone pnącza",
  "block.minecraft.sugar_cane": "trzcina cukrowa",
  "block.minecraft.kelp": "wodorost",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "blok złota",
  "block.minecraft.iron_block": "blok żelaza",
  "block.minecraft.oak_slab": "dębowa płyta",
  "block.minecraft.spruce_slab": "świerkowa płyta",
  "block.minecraft.birch_slab": "brzozowa płyta",
  "block.minecraft.jungle_slab": "tropikalna płyta",
  "block.minecraft.acacia_slab": "akacjowa płyta",
  "block.minecraft.dark_oak_slab": "ciemnodębowa płyta",
  "block.minecraft.crimson_slab": "szkarłatna płyta",
  "block.minecraft.warped_slab": "spaczona płyta",
  "block.minecraft.stone_slab": "kamienna płyta",
  "block.minecraft.smooth_stone_slab": "gładka kamienna płyta",
  "block.minecraft.sandstone_slab": "piaskowcowa płyta",
  "block.minecraft.cut_sandstone_slab": "przycięta piaskowcowa płyta",
  "block.minecraft.petrified_oak_slab": "skamieniała dębowa płyta",
  "block.minecraft.cobblestone_slab": "brukowa płyta",
  "block.minecraft.brick_slab": "ceglana płyta",
  "block.minecraft.stone_brick_slab": "kamienna ceglana płyta",
  "block.minecraft.nether_brick_slab": "netherowa ceglana płyta",
  "block.minecraft.quartz_slab": "kwarcowa płyta",
  "block.minecraft.red_sandstone_slab": "czerwona piaskowcowa płyta",
  "block.minecraft.cut_red_sandstone_slab": "przycięta czerwona piaskowcowa płyta",
  "block.minecraft.purpur_slab": "purpurowa płyta",
  "block.minecraft.prismarine_slab": "pryzmarynowa płyta",
  "block.minecraft.prismarine_brick_slab": "pryzmarynowa ceglana płyta",
  "block.minecraft.dark_prismarine_slab": "ciemna pryzmarynowa płyta",
  "block.minecraft.smooth_quartz": "gładki blok kwarcu",
  "block.minecraft.smooth_red_sandstone": "gładki czerwony piaskowiec",
  "block.minecraft.smooth_sandstone": "gładki piaskowiec",
  "block.minecraft.smooth_stone": "gładki kamień",
  "block.minecraft.bricks": "cegły",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "biblioteczka",
  "block.minecraft.mossy_cobblestone": "zamszony bruk",
  "block.minecraft.obsidian": "obsydian",
  "block.minecraft.torch": "pochodnia",
  "block.minecraft.end_rod": "endowy słupek",
  "block.minecraft.chorus_plant": "łodyga refrenusu",
  "block.minecraft.chorus_flower": "kwiat refrenusu",
  "block.minecraft.purpur_block": "blok purpuru",
  "block.minecraft.purpur_pillar": "purpurowy filar",
  "block.minecraft.purpur_stairs": "purpurowe schody",
  "block.minecraft.spawner": "spawner",
  "block.minecraft.oak_stairs": "dębowe schody",
  "block.minecraft.chest": "skrzynia",
  "block.minecraft.diamond_ore": "złoże diamentu",
  "block.minecraft.diamond_block": "blok diamentu",
  "block.minecraft.crafting_table": "stół rzemieślniczy",
  "block.minecraft.farmland": "pole uprawne",
  "block.minecraft.furnace": "piec",
  "block.minecraft.ladder": "drabina",
  "block.minecraft.rail": "tory",
  "block.minecraft.cobblestone_stairs": "brukowe schody",
  "block.minecraft.lever": "dźwignia",
  "block.minecraft.stone_pressure_plate": "kamienna płyta naciskowa",
  "block.minecraft.oak_pressure_plate": "dębowa płyta naciskowa",
  "block.minecraft.spruce_pressure_plate": "świerkowa płyta naciskowa",
  "block.minecraft.birch_pressure_plate": "brzozowa płyta naciskowa",
  "block.minecraft.jungle_pressure_plate": "tropikalna płyta naciskowa",
  "block.minecraft.acacia_pressure_plate": "akacjowa płyta naciskowa",
  "block.minecraft.dark_oak_pressure_plate": "ciemnodębowa płyta naciskowa",
  "block.minecraft.crimson_pressure_plate": "szkarłatna płyta naciskowa",
  "block.minecraft.warped_pressure_plate": "spaczona płyta naciskowa",
  "block.minecraft.polished_blackstone_pressure_plate": "wypolerowana czernitowa płytka naciskowa",
  "block.minecraft.redstone_ore": "złoże redstone",
  "block.minecraft.redstone_torch": "pochodnia redstone",
  "block.minecraft.snow": "śnieg",
  "block.minecraft.ice": "lód",
  "block.minecraft.snow_block": "blok śniegu",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "glina",
  "block.minecraft.jukebox": "szafa grająca",
  "block.minecraft.oak_fence": "dębowy płot",
  "block.minecraft.spruce_fence": "świerkowy płot",
  "block.minecraft.birch_fence": "brzozowy płot",
  "block.minecraft.jungle_fence": "tropikalny płot",
  "block.minecraft.acacia_fence": "akacjowy płot",
  "block.minecraft.dark_oak_fence": "ciemnodębowy płot",
  "block.minecraft.crimson_fence": "szkarłatny płot",
  "block.minecraft.warped_fence": "spaczony płot",
  "block.minecraft.pumpkin": "dynia",
  "block.minecraft.carved_pumpkin": "wykrawana dynia",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "piasek dusz",
  "block.minecraft.soul_soil": "gleba dusz",
  "block.minecraft.basalt": "bazalt",
  "block.minecraft.polished_basalt": "wypolerowany bazalt",
  "block.minecraft.soul_torch": "pochodnia dusz",
  "block.minecraft.glowstone": "jasnogłaz",
  "block.minecraft.jack_o_lantern": "jack o'lantern",
  "block.minecraft.oak_trapdoor": "dębowa klapa",
  "block.minecraft.spruce_trapdoor": "świerkowa klapa",
  "block.minecraft.birch_trapdoor": "brzozowa klapa",
  "block.minecraft.jungle_trapdoor": "tropikalna klapa",
  "block.minecraft.acacia_trapdoor": "akacjowa klapa",
  "block.minecraft.dark_oak_trapdoor": "ciemnodębowa klapa",
  "block.minecraft.crimson_trapdoor": "szkarłatna klapa",
  "block.minecraft.warped_trapdoor": "spaczona klapa",
  "block.minecraft.infested_stone": "zarobaczony kamień",
  "block.minecraft.infested_cobblestone": "zarobaczony bruk",
  "block.minecraft.infested_stone_bricks": "zarobaczone kamienne cegły",
  "block.minecraft.infested_mossy_stone_bricks": "zarobaczone zamszone kamienne cegły",
  "block.minecraft.infested_cracked_stone_bricks": "zarobaczone popękane kamienne cegły",
  "block.minecraft.infested_chiseled_stone_bricks": "zarobaczone rzeźbione kamienne cegły",
  "block.minecraft.stone_bricks": "kamienne cegły",
  "block.minecraft.mossy_stone_bricks": "zamszone kamienne cegły",
  "block.minecraft.cracked_stone_bricks": "popękane kamienne cegły",
  "block.minecraft.chiseled_stone_bricks": "rzeźbione kamienne cegły",
  "block.minecraft.brown_mushroom_block": "blok borowika",
  "block.minecraft.red_mushroom_block": "blok muchomora",
  "block.minecraft.mushroom_stem": "trzon grzyba",
  "block.minecraft.iron_bars": "żelazne kraty",
  "block.minecraft.chain": "łańcuch",
  "block.minecraft.glass_pane": "szyba",
  "block.minecraft.melon": "arbuz",
  "block.minecraft.vine": "pnącza",
  "block.minecraft.oak_fence_gate": "dębowa furtka",
  "block.minecraft.spruce_fence_gate": "świerkowa furtka",
  "block.minecraft.birch_fence_gate": "brzozowa furtka",
  "block.minecraft.jungle_fence_gate": "tropikalna furtka",
  "block.minecraft.acacia_fence_gate": "akacjowa furtka",
  "block.minecraft.dark_oak_fence_gate": "ciemnodębowa furtka",
  "block.minecraft.crimson_fence_gate": "szkarłatna furtka",
  "block.minecraft.warped_fence_gate": "spaczona furtka",
  "block.minecraft.brick_stairs": "ceglane schody",
  "block.minecraft.stone_brick_stairs": "kamienne ceglane schody",
  "block.minecraft.mycelium": "grzybnia",
  "block.minecraft.lily_pad": "lilia wodna",
  "block.minecraft.nether_bricks": "netherowe cegły",
  "block.minecraft.cracked_nether_bricks": "popękane netherowe cegły",
  "block.minecraft.chiseled_nether_bricks": "rzeźbione netherowe cegły",
  "block.minecraft.nether_brick_fence": "netherowy ceglany płot",
  "block.minecraft.nether_brick_stairs": "netherowe ceglane schody",
  "block.minecraft.enchanting_table": "stół do zaklinania",
  "block.minecraft.end_portal_frame": "rama portalu do endu",
  "block.minecraft.end_stone": "kamień endu",
  "block.minecraft.end_stone_bricks": "endowe kamienne cegły",
  "block.minecraft.dragon_egg": "smocze jajo",
  "block.minecraft.redstone_lamp": "lampa",
  "block.minecraft.sandstone_stairs": "piaskowcowe schody",
  "block.minecraft.emerald_ore": "złoże szmaragdu",
  "block.minecraft.ender_chest": "skrzynia endu",
  "block.minecraft.tripwire_hook": "zaczep na linkę",
  "block.minecraft.emerald_block": "blok szmaragdu",
  "block.minecraft.spruce_stairs": "świerkowe schody",
  "block.minecraft.birch_stairs": "brzozowe schody",
  "block.minecraft.jungle_stairs": "tropikalne schody",
  "block.minecraft.crimson_stairs": "szkarłatne schody",
  "block.minecraft.warped_stairs": "spaczone schody",
  "block.minecraft.command_block": "blok poleceń",
  "block.minecraft.beacon": "magiczna latarnia",
  "block.minecraft.cobblestone_wall": "brukowy murek",
  "block.minecraft.mossy_cobblestone_wall": "zamszony brukowy murek",
  "block.minecraft.brick_wall": "ceglany murek",
  "block.minecraft.prismarine_wall": "pryzmarynowy murek",
  "block.minecraft.red_sandstone_wall": "czerwony piaskowcowy murek",
  "block.minecraft.mossy_stone_brick_wall": "zamszony kamienny ceglany murek",
  "block.minecraft.granite_wall": "granitowy murek",
  "block.minecraft.stone_brick_wall": "kamienny ceglany murek",
  "block.minecraft.nether_brick_wall": "netherowy ceglany murek",
  "block.minecraft.andesite_wall": "andezytowy murek",
  "block.minecraft.red_nether_brick_wall": "czerwony netherowy ceglany murek",
  "block.minecraft.sandstone_wall": "piaskowcowy murek",
  "block.minecraft.end_stone_brick_wall": "endowy kamienny ceglany murek",
  "block.minecraft.diorite_wall": "diorytowy murek",
  "block.minecraft.blackstone_wall": "czernitowy murek",
  "block.minecraft.polished_blackstone_wall": "wypolerowany czernitowy murek",
  "block.minecraft.polished_blackstone_brick_wall": "wypolerowany czernitowy ceglany murek",
  "block.minecraft.stone_button": "kamienny przycisk",
  "block.minecraft.oak_button": "dębowy przycisk",
  "block.minecraft.spruce_button": "świerkowy przycisk",
  "block.minecraft.birch_button": "brzozowy przycisk",
  "block.minecraft.jungle_button": "tropikalny przycisk",
  "block.minecraft.acacia_button": "akacjowy przycisk",
  "block.minecraft.dark_oak_button": "ciemnodębowy przycisk",
  "block.minecraft.crimson_button": "szkarłatny przycisk",
  "block.minecraft.warped_button": "spaczony przycisk",
  "block.minecraft.polished_blackstone_button": "wypolerowany czernitowy przycisk",
  "block.minecraft.anvil": "kowadło",
  "block.minecraft.chipped_anvil": "wyszczerbione kowadło",
  "block.minecraft.damaged_anvil": "uszkodzone kowadło",
  "block.minecraft.trapped_chest": "skrzynia-pułapka",
  "block.minecraft.light_weighted_pressure_plate": "lekka płyta naciskowa",
  "block.minecraft.heavy_weighted_pressure_plate": "ciężka płyta naciskowa",
  "block.minecraft.daylight_detector": "detektor światła dziennego",
  "block.minecraft.redstone_block": "blok redstone",
  "block.minecraft.nether_quartz_ore": "złoże kwarcu",
  "block.minecraft.hopper": "lej",
  "block.minecraft.chiseled_quartz_block": "rzeźbiony blok kwarcu",
  "block.minecraft.quartz_block": "blok kwarcu",
  "block.minecraft.quartz_bricks": "kwarcowe cegły",
  "block.minecraft.quartz_pillar": "kwarcowy filar",
  "block.minecraft.quartz_stairs": "kwarcowe schody",
  "block.minecraft.activator_rail": "tory aktywacyjne",
  "block.minecraft.dropper": "podajnik",
  "block.minecraft.white_terracotta": "biała terakota",
  "block.minecraft.orange_terracotta": "pomarańczowa terakota",
  "block.minecraft.magenta_terracotta": "karmazynowa terakota",
  "block.minecraft.light_blue_terracotta": "jasnoniebieska terakota",
  "block.minecraft.yellow_terracotta": "żółta terakota",
  "block.minecraft.lime_terracotta": "jasnozielona terakota",
  "block.minecraft.pink_terracotta": "różowa terakota",
  "block.minecraft.gray_terracotta": "szara terakota",
  "block.minecraft.light_gray_terracotta": "jasnoszara terakota",
  "block.minecraft.cyan_terracotta": "błękitna terakota",
  "block.minecraft.purple_terracotta": "fioletowa terakota",
  "block.minecraft.blue_terracotta": "niebieska terakota",
  "block.minecraft.brown_terracotta": "brązowa terakota",
  "block.minecraft.green_terracotta": "zielona terakota",
  "block.minecraft.red_terracotta": "czerwona terakota",
  "block.minecraft.black_terracotta": "czarna terakota",
  "block.minecraft.barrier": "bariera",
  "block.minecraft.iron_trapdoor": "żelazna klapa",
  "block.minecraft.hay_block": "snop siana",
  "block.minecraft.white_carpet": "biały dywan",
  "block.minecraft.orange_carpet": "pomarańczowy dywan",
  "block.minecraft.magenta_carpet": "karmazynowy dywan",
  "block.minecraft.light_blue_carpet": "jasnoniebieski dywan",
  "block.minecraft.yellow_carpet": "żółty dywan",
  "block.minecraft.lime_carpet": "jasnozielony dywan",
  "block.minecraft.pink_carpet": "różowy dywan",
  "block.minecraft.gray_carpet": "szary dywan",
  "block.minecraft.light_gray_carpet": "jasnoszary dywan",
  "block.minecraft.cyan_carpet": "błękitny dywan",
  "block.minecraft.purple_carpet": "fioletowy dywan",
  "block.minecraft.blue_carpet": "niebieski dywan",
  "block.minecraft.brown_carpet": "brązowy dywan",
  "block.minecraft.green_carpet": "zielony dywan",
  "block.minecraft.red_carpet": "czerwony dywan",
  "block.minecraft.black_carpet": "czarny dywan",
  "block.minecraft.terracotta": "terakota",
  "block.minecraft.coal_block": "blok węgla",
  "block.minecraft.packed_ice": "zbity lód",
  "block.minecraft.acacia_stairs": "akacjowe schody",
  "block.minecraft.dark_oak_stairs": "ciemnodębowe schody",
  "block.minecraft.slime_block": "blok szlamu",
  "block.minecraft.grass_path": "ścieżka",
  "block.minecraft.sunflower": "słonecznik",
  "block.minecraft.lilac": "bez",
  "block.minecraft.rose_bush": "krzew róży",
  "block.minecraft.peony": "piwonia",
  "block.minecraft.tall_grass": "wysoka trawa",
  "block.minecraft.large_fern": "duża paproć",
  "block.minecraft.white_stained_glass": "białe szkło",
  "block.minecraft.orange_stained_glass": "pomarańczowe szkło",
  "block.minecraft.magenta_stained_glass": "karmazynowe szkło",
  "block.minecraft.light_blue_stained_glass": "jasnoniebieskie szkło",
  "block.minecraft.yellow_stained_glass": "żółte szkło",
  "block.minecraft.lime_stained_glass": "jasnozielone szkło",
  "block.minecraft.pink_stained_glass": "różowe szkło",
  "block.minecraft.gray_stained_glass": "szare szkło",
  "block.minecraft.light_gray_stained_glass": "jasnoszare szkło",
  "block.minecraft.cyan_stained_glass": "błękitne szkło",
  "block.minecraft.purple_stained_glass": "fioletowe szkło",
  "block.minecraft.blue_stained_glass": "niebieskie szkło",
  "block.minecraft.brown_stained_glass": "brązowe szkło",
  "block.minecraft.green_stained_glass": "zielone szkło",
  "block.minecraft.red_stained_glass": "czerwone szkło",
  "block.minecraft.black_stained_glass": "czarne szkło",
  "block.minecraft.white_stained_glass_pane": "biała szyba",
  "block.minecraft.orange_stained_glass_pane": "pomarańczowa szyba",
  "block.minecraft.magenta_stained_glass_pane": "karmazynowa szyba",
  "block.minecraft.light_blue_stained_glass_pane": "jasnoniebieska szyba",
  "block.minecraft.yellow_stained_glass_pane": "żółta szyba",
  "block.minecraft.lime_stained_glass_pane": "jasnozielona szyba",
  "block.minecraft.pink_stained_glass_pane": "różowa szyba",
  "block.minecraft.gray_stained_glass_pane": "szara szyba",
  "block.minecraft.light_gray_stained_glass_pane": "jasnoszara szyba",
  "block.minecraft.cyan_stained_glass_pane": "błękitna szyba",
  "block.minecraft.purple_stained_glass_pane": "fioletowa szyba",
  "block.minecraft.blue_stained_glass_pane": "niebieska szyba",
  "block.minecraft.brown_stained_glass_pane": "brązowa szyba",
  "block.minecraft.green_stained_glass_pane": "zielona szyba",
  "block.minecraft.red_stained_glass_pane": "czerwona szyba",
  "block.minecraft.black_stained_glass_pane": "czarna szyba",
  "block.minecraft.prismarine": "pryzmaryn",
  "block.minecraft.prismarine_bricks": "pryzmarynowe cegły",
  "block.minecraft.dark_prismarine": "ciemny pryzmaryn",
  "block.minecraft.prismarine_stairs": "pryzmarynowe schody",
  "block.minecraft.prismarine_brick_stairs": "pryzmarynowe ceglane schody",
  "block.minecraft.dark_prismarine_stairs": "ciemne pryzmarynowe schody",
  "block.minecraft.sea_lantern": "latarnia morska",
  "block.minecraft.red_sandstone": "czerwony piaskowiec",
  "block.minecraft.chiseled_red_sandstone": "rzeźbiony czerwony piaskowiec",
  "block.minecraft.cut_red_sandstone": "przycięty czerwony piaskowiec",
  "block.minecraft.red_sandstone_stairs": "czerwone piaskowcowe schody",
  "block.minecraft.repeating_command_block": "powtarzający blok poleceń",
  "block.minecraft.chain_command_block": "łańcuchowy blok poleceń",
  "block.minecraft.magma_block": "blok magmy",
  "block.minecraft.nether_wart_block": "blok netherowych brodawek",
  "block.minecraft.warped_wart_block": "blok spaczonych brodawek",
  "block.minecraft.red_nether_bricks": "czerwone netherowe cegły",
  "block.minecraft.bone_block": "blok kości",
  "block.minecraft.structure_void": "pustka strukturalna",
  "block.minecraft.observer": "detektor",
  "block.minecraft.shulker_box": "shulkerowa skrzynia",
  "block.minecraft.white_shulker_box": "biała shulkerowa skrzynia",
  "block.minecraft.orange_shulker_box": "pomarańczowa shulkerowa skrzynia",
  "block.minecraft.magenta_shulker_box": "karmazynowa shulkerowa skrzynia",
  "block.minecraft.light_blue_shulker_box": "jasnoniebieska shulkerowa skrzynia",
  "block.minecraft.yellow_shulker_box": "żółta shulkerowa skrzynia",
  "block.minecraft.lime_shulker_box": "jasnozielona shulkerowa skrzynia",
  "block.minecraft.pink_shulker_box": "różowa shulkerowa skrzynia",
  "block.minecraft.gray_shulker_box": "szara shulkerowa skrzynia",
  "block.minecraft.light_gray_shulker_box": "jasnoszara shulkerowa skrzynia",
  "block.minecraft.cyan_shulker_box": "błękitna shulkerowa skrzynia",
  "block.minecraft.purple_shulker_box": "fioletowa shulkerowa skrzynia",
  "block.minecraft.blue_shulker_box": "niebieska shulkerowa skrzynia",
  "block.minecraft.brown_shulker_box": "brązowa shulkerowa skrzynia",
  "block.minecraft.green_shulker_box": "zielona shulkerowa skrzynia",
  "block.minecraft.red_shulker_box": "czerwona shulkerowa skrzynia",
  "block.minecraft.black_shulker_box": "czarna shulkerowa skrzynia",
  "block.minecraft.white_glazed_terracotta": "biała glazurowana terakota",
  "block.minecraft.orange_glazed_terracotta": "pomarańczowa glazurowana terakota",
  "block.minecraft.magenta_glazed_terracotta": "karmazynowa glazurowana terakota",
  "block.minecraft.light_blue_glazed_terracotta": "jasnoniebieska glazurowana terakota",
  "block.minecraft.yellow_glazed_terracotta": "żółta glazurowana terakota",
  "block.minecraft.lime_glazed_terracotta": "jasnozielona glazurowana terakota",
  "block.minecraft.pink_glazed_terracotta": "różowa glazurowana terakota",
  "block.minecraft.gray_glazed_terracotta": "szara glazurowana terakota",
  "block.minecraft.light_gray_glazed_terracotta": "jasnoszara glazurowana terakota",
  "block.minecraft.cyan_glazed_terracotta": "błękitna glazurowana terakota",
  "block.minecraft.purple_glazed_terracotta": "fioletowa glazurowana terakota",
  "block.minecraft.blue_glazed_terracotta": "niebieska glazurowana terakota",
  "block.minecraft.brown_glazed_terracotta": "brązowa glazurowana terakota",
  "block.minecraft.green_glazed_terracotta": "zielona glazurowana terakota",
  "block.minecraft.red_glazed_terracotta": "czerwona glazurowana terakota",
  "block.minecraft.black_glazed_terracotta": "czarna glazurowana terakota",
  "block.minecraft.white_concrete": "biały beton",
  "block.minecraft.orange_concrete": "pomarańczowy beton",
  "block.minecraft.magenta_concrete": "karmazynowy beton",
  "block.minecraft.light_blue_concrete": "jasnoniebieski beton",
  "block.minecraft.yellow_concrete": "żółty beton",
  "block.minecraft.lime_concrete": "jasnozielony beton",
  "block.minecraft.pink_concrete": "różowy beton",
  "block.minecraft.gray_concrete": "szary beton",
  "block.minecraft.light_gray_concrete": "jasnoszary beton",
  "block.minecraft.cyan_concrete": "błękitny beton",
  "block.minecraft.purple_concrete": "fioletowy beton",
  "block.minecraft.blue_concrete": "niebieski beton",
  "block.minecraft.brown_concrete": "brązowy beton",
  "block.minecraft.green_concrete": "zielony beton",
  "block.minecraft.red_concrete": "czerwony beton",
  "block.minecraft.black_concrete": "czarny beton",
  "block.minecraft.white_concrete_powder": "biały cement",
  "block.minecraft.orange_concrete_powder": "pomarańczowy cement",
  "block.minecraft.magenta_concrete_powder": "karmazynowy cement",
  "block.minecraft.light_blue_concrete_powder": "jasnoniebieski cement",
  "block.minecraft.yellow_concrete_powder": "żółty cement",
  "block.minecraft.lime_concrete_powder": "jasnozielony cement",
  "block.minecraft.pink_concrete_powder": "różowy cement",
  "block.minecraft.gray_concrete_powder": "szary cement",
  "block.minecraft.light_gray_concrete_powder": "jasnoszary cement",
  "block.minecraft.cyan_concrete_powder": "błękitny cement",
  "block.minecraft.purple_concrete_powder": "fioletowy cement",
  "block.minecraft.blue_concrete_powder": "niebieski cement",
  "block.minecraft.brown_concrete_powder": "brązowy cement",
  "block.minecraft.green_concrete_powder": "zielony cement",
  "block.minecraft.red_concrete_powder": "czerwony cement",
  "block.minecraft.black_concrete_powder": "czarny cement",
  "block.minecraft.turtle_egg": "żółwie jajko",
  "block.minecraft.dead_tube_coral_block": "blok martwego koralowca rurkowatego",
  "block.minecraft.dead_brain_coral_block": "blok martwego koralowca mózgowatego",
  "block.minecraft.dead_bubble_coral_block": "blok martwego koralowca bąbelkowatego",
  "block.minecraft.dead_fire_coral_block": "blok martwego koralowca ognistego",
  "block.minecraft.dead_horn_coral_block": "blok martwego koralowca rogatego",
  "block.minecraft.tube_coral_block": "blok koralowca rurkowatego",
  "block.minecraft.brain_coral_block": "blok koralowca mózgowatego",
  "block.minecraft.bubble_coral_block": "blok koralowca bąbelkowatego",
  "block.minecraft.fire_coral_block": "blok koralowca ognistego",
  "block.minecraft.horn_coral_block": "blok koralowca rogatego",
  "block.minecraft.tube_coral": "koralowiec rurkowaty",
  "block.minecraft.brain_coral": "koralowiec mózgowaty",
  "block.minecraft.bubble_coral": "koralowiec bąbelkowaty",
  "block.minecraft.fire_coral": "koralowiec ognisty",
  "block.minecraft.horn_coral": "koralowiec rogaty",
  "block.minecraft.dead_brain_coral": "martwy koralowiec mózgowaty",
  "block.minecraft.dead_bubble_coral": "martwy koralowiec bąbelkowy",
  "block.minecraft.dead_fire_coral": "martwy koralowiec ognisty",
  "block.minecraft.dead_horn_coral": "martwy koralowiec rogaty",
  "block.minecraft.dead_tube_coral": "martwy koralowiec rurkowaty",
  "block.minecraft.tube_coral_fan": "wachlarz koralowca rurkowatego",
  "block.minecraft.brain_coral_fan": "wachlarz koralowca mózgowatego",
  "block.minecraft.bubble_coral_fan": "wachlarz koralowca bąbelkowatego",
  "block.minecraft.fire_coral_fan": "wachlarz koralowca ognistego",
  "block.minecraft.horn_coral_fan": "wachlarz koralowca rogatego",
  "block.minecraft.dead_tube_coral_fan": "martwy wachlarz koralowca rurkowatego",
  "block.minecraft.dead_brain_coral_fan": "martwy wachlarz koralowca mózgowatego",
  "block.minecraft.dead_bubble_coral_fan": "martwy wachlarz koralowca bąbelkowatego",
  "block.minecraft.dead_fire_coral_fan": "martwy wachlarz koralowca ognistego",
  "block.minecraft.dead_horn_coral_fan": "martwy wachlarz koralowca rogatego",
  "block.minecraft.blue_ice": "niebieski lód lodowcowy",
  "block.minecraft.conduit": "przewodnia",
  "block.minecraft.polished_granite_stairs": "wypolerowane granitowe schody",
  "block.minecraft.smooth_red_sandstone_stairs": "gładkie czerwone piaskowcowe schody",
  "block.minecraft.mossy_stone_brick_stairs": "zamszone kamienne ceglane schody",
  "block.minecraft.polished_diorite_stairs": "wypolerowane diorytowe schody",
  "block.minecraft.mossy_cobblestone_stairs": "zamszone brukowe schody",
  "block.minecraft.end_stone_brick_stairs": "endowe kamienne ceglane schody",
  "block.minecraft.stone_stairs": "kamienne schody",
  "block.minecraft.smooth_sandstone_stairs": "gładkie piaskowcowe schody",
  "block.minecraft.smooth_quartz_stairs": "gładkie kwarcowe schody",
  "block.minecraft.granite_stairs": "granitowe schody",
  "block.minecraft.andesite_stairs": "andezytowe schody",
  "block.minecraft.red_nether_brick_stairs": "czerwone netherowe ceglane schody",
  "block.minecraft.polished_andesite_stairs": "wypolerowane andezytowe schody",
  "block.minecraft.diorite_stairs": "diorytowe schody",
  "block.minecraft.polished_granite_slab": "wypolerowana granitowa płyta",
  "block.minecraft.smooth_red_sandstone_slab": "gładka czerwona piaskowcowa płyta",
  "block.minecraft.mossy_stone_brick_slab": "zamszona kamienna ceglana płyta",
  "block.minecraft.polished_diorite_slab": "wypolerowana diorytowa płyta",
  "block.minecraft.mossy_cobblestone_slab": "zamszona brukowa płyta",
  "block.minecraft.end_stone_brick_slab": "endowa kamienna ceglana płyta",
  "block.minecraft.smooth_sandstone_slab": "gładka piaskowcowa płyta",
  "block.minecraft.smooth_quartz_slab": "gładka kwarcowa płyta",
  "block.minecraft.granite_slab": "granitowa płyta",
  "block.minecraft.andesite_slab": "andezytowa płyta",
  "block.minecraft.red_nether_brick_slab": "czerwona netherowa ceglana płyta",
  "block.minecraft.polished_andesite_slab": "wypolerowana andezytowa płyta",
  "block.minecraft.diorite_slab": "diorytowa płyta",
  "block.minecraft.scaffolding": "rusztowanie",
  "block.minecraft.iron_door": "żelazne drzwi",
  "block.minecraft.oak_door": "dębowe drzwi",
  "block.minecraft.spruce_door": "świerkowe drzwi",
  "block.minecraft.birch_door": "brzozowe drzwi",
  "block.minecraft.jungle_door": "tropikalne drzwi",
  "block.minecraft.acacia_door": "akacjowe drzwi",
  "block.minecraft.dark_oak_door": "ciemnodębowe drzwi",
  "block.minecraft.crimson_door": "szkarłatne drzwi",
  "block.minecraft.warped_door": "spaczone drzwi",
  "block.minecraft.repeater": "przekaźnik",
  "block.minecraft.comparator": "komparator",
  "block.minecraft.structure_block": "blok struktur",
  "block.minecraft.jigsaw": "blok konstrukcyjny",
  "item.minecraft.turtle_helmet": "żółwia skorupa□□kiedy na głowie:□+2 do zbroi",
  "item.minecraft.scute": "tarczka",
  "item.minecraft.iron_shovel": "żelazna łopata□□kiedy w głównej ręce:□+3.5 do obrażeń□-3 od szybkości ataku",
  "item.minecraft.iron_pickaxe": "żelazny kilof□□kiedy w głównej ręce:□+3 do obrażeń□-2.8 od szybkości ataku",
  "item.minecraft.iron_axe": "żelazna siekiera□□kiedy w głównej ręce:□+8 do obrażeń□-3.1 od szybkości ataku",
  "item.minecraft.flint_and_steel": "krzesiwo",
  "item.minecraft.apple": "jabłko",
  "item.minecraft.bow": "łuk",
  "item.minecraft.arrow": "strzała",
  "item.minecraft.coal": "węgiel",
  "item.minecraft.charcoal": "węgiel drzewny",
  "item.minecraft.diamond": "diament",
  "item.minecraft.iron_ingot": "sztabka żelaza",
  "item.minecraft.gold_ingot": "sztabka złota",
  "item.minecraft.netherite_ingot": "sztabka netherytu",
  "item.minecraft.netherite_scrap": "odłamek netherytu",
  "item.minecraft.iron_sword": "żelazny miecz□□kiedy w głównej ręce:□+5 do obrażeń□-2.4 od szybkości ataku",
  "item.minecraft.wooden_sword": "drewniany miecz□□kiedy w głównej ręce:□+3 do obrażeń□-2.4 od szybkości ataku",
  "item.minecraft.wooden_shovel": "drewniana łopata□□kiedy w głównej ręce:□+1.5 do obrażeń□-3 od szybkości ataku",
  "item.minecraft.wooden_pickaxe": "drewniany kilof□□kiedy w głównej ręce:□+1 do obrażeń□-2.8 od szybkości ataku",
  "item.minecraft.wooden_axe": "drewniana siekiera□□kiedy w głównej ręce:□+6 do obrażeń□-3.2 od szybkości ataku",
  "item.minecraft.stone_sword": "kamienny miecz□□kiedy w głównej ręce:□+4 do obrażeń□-2.4 od szybkości ataku",
  "item.minecraft.stone_shovel": "kamienna łopata□□kiedy w głównej ręce:□+2.5 do obrażeń□-3 od szybkości ataku",
  "item.minecraft.stone_pickaxe": "kamienny kilof□□kiedy w głównej ręce:□+2 do obrażeń□-2.8 od szybkości ataku",
  "item.minecraft.stone_axe": "kamienna siekiera□□kiedy w głównej ręce:□+8 do obrażeń□-3.2 od szybkości ataku",
  "item.minecraft.diamond_sword": "diamentowy miecz□□kiedy w głównej ręce:□+6 do obrażeń□-2.4 od szybkości ataku",
  "item.minecraft.diamond_shovel": "diamentowa łopata□□kiedy w głównej ręce:□+4.5 do obrażeń□-3 od szybkości ataku",
  "item.minecraft.diamond_pickaxe": "diamentowy kilof□□kiedy w głównej ręce:□+4 do obrażeń□-2.8 od szybkości ataku",
  "item.minecraft.diamond_axe": "diamentowa siekiera□□kiedy w głównej ręce:□+8 do obrażeń□-3 od szybkości ataku",
  "item.minecraft.stick": "patyk",
  "item.minecraft.bowl": "miska",
  "item.minecraft.mushroom_stew": "zupa grzybowa",
  "item.minecraft.golden_sword": "złoty miecz□□kiedy w głównej ręce:□+3 do obrażeń□-2.4 od szybkości ataku",
  "item.minecraft.golden_shovel": "złota łopata□□kiedy w głównej ręce:□+1.5 do obrażeń□-3 od szybkości ataku",
  "item.minecraft.golden_pickaxe": "złoty kilof□□kiedy w głównej ręce:□+1 do obrażeń□-2.8 od szybkości ataku",
  "item.minecraft.golden_axe": "złota siekiera□□kiedy w głównej ręce:□+6 do obrażeń□-3 od szybkości ataku",
  "item.minecraft.netherite_sword": "netherytowy miecz□□kiedy w głównej ręce:□+7 do obrażeń□-2.4 od szybkości ataku",
  "item.minecraft.netherite_shovel": "netherytowa łopata□□kiedy w głównej ręce:□+5.5 do obrażeń□-3 od szybkości ataku",
  "item.minecraft.netherite_pickaxe": "netherytowy kilof□□kiedy w głównej ręce:□+5 do obrażeń□-2.8 od szybkości ataku",
  "item.minecraft.netherite_axe": "netherytowa siekiera□□kiedy w głównej ręce:□+9 do obrażeń□-3 od szybkości ataku",
  "item.minecraft.string": "nić",
  "item.minecraft.feather": "pióro",
  "item.minecraft.gunpowder": "proch",
  "item.minecraft.wooden_hoe": "drewniana motyka□□kiedy w głównej ręce:□-3 od szybkości ataku",
  "item.minecraft.stone_hoe": "kamienna motyka□□kiedy w głównej ręce:□-2 od szybkości ataku",
  "item.minecraft.iron_hoe": "żelazna motyka□□kiedy w głównej ręce:□-1 od szybkości ataku",
  "item.minecraft.diamond_hoe": "diamentowa motyka□□kiedy w głównej ręce:",
  "item.minecraft.golden_hoe": "złota motyka□□kiedy w głównej ręce:□-3 od szybkości ataku",
  "item.minecraft.netherite_hoe": "netherytowa motyka□□kiedy w głównej ręce:",
  "item.minecraft.wheat_seeds": "nasiona pszenicy",
  "item.minecraft.wheat": "pszenica",
  "item.minecraft.bread": "chleb",
  "item.minecraft.leather_helmet": "skórzana czapka□□kiedy na głowie:□+1 do zbroi",
  "item.minecraft.leather_chestplate": "skórzana tunika□□kiedy na torsie:□+3 do zbroi",
  "item.minecraft.leather_leggings": "skórzane spodnie□□kiedy na nogach:□+2 do zbroi",
  "item.minecraft.leather_boots": "skórzane buty□□kiedy na stopach:□+1 do zbroi",
  "item.minecraft.chainmail_helmet": "hełm kolczy□□kiedy na głowie:□+2 do zbroi",
  "item.minecraft.chainmail_chestplate": "napierśnik kolczy□□kiedy na torsie:□+5 do zbroi",
  "item.minecraft.chainmail_leggings": "nogawice kolcze□□kiedy na nogach:□+4 do zbroi",
  "item.minecraft.chainmail_boots": "buty kolcze□□kiedy na stopach:□+1 do zbroi",
  "item.minecraft.iron_helmet": "żelazny hełm□□kiedy na głowie:□+2 do zbroi",
  "item.minecraft.iron_chestplate": "żelazny napierśnik□□kiedy na torsie:□+6 do zbroi",
  "item.minecraft.iron_leggings": "żelazne nogawice□□kiedy na nogach:□+5 do zbroi",
  "item.minecraft.iron_boots": "żelazne buty□□kiedy na stopach:□+2 do zbroi",
  "item.minecraft.diamond_helmet": "diamentowy hełm□□kiedy na głowie:□+3 do zbroi□+2 do wytrzymałości zbroi",
  "item.minecraft.diamond_chestplate": "diamentowy napierśnik□□kiedy na torsie:□+8 do zbroi□+2 do wytrzymałości zbroi",
  "item.minecraft.diamond_leggings": "diamentowe nogawice□□kiedy na nogach:□+6 do zbroi□+2 do wytrzymałości zbroi",
  "item.minecraft.diamond_boots": "diamentowe buty□□kiedy na stopach:□+3 do zbroi□+2 do wytrzymałości zbroi",
  "item.minecraft.golden_helmet": "złoty hełm□□kiedy na głowie:□+2 do zbroi",
  "item.minecraft.golden_chestplate": "złoty napierśnik□□kiedy na torsie:□+5 do zbroi",
  "item.minecraft.golden_leggings": "złote nogawice□□kiedy na nogach:□+3 do zbroi",
  "item.minecraft.golden_boots": "złote buty□□kiedy na stopach:□+1 do zbroi",
  "item.minecraft.netherite_helmet": "netherytowy hełm□□kiedy na głowie:□+3 do zbroi□+3 do wytrzymałości zbroi□+1 do odporności na odrzut",
  "item.minecraft.netherite_chestplate": "netherytowy napierśnik□□kiedy na torsie:□+8 do zbroi□+3 do wytrzymałości zbroi□+1 do odporności na odrzut",
  "item.minecraft.netherite_leggings": "netherytowe nogawice□□kiedy na nogach:□+6 do zbroi□+3 do wytrzymałości zbroi□+1 do odporności na odrzut",
  "item.minecraft.netherite_boots": "netherytowe buty□□kiedy na stopach:□+3 do zbroi□+3 do wytrzymałości zbroi□+1 do odporności na odrzut",
  "item.minecraft.flint": "krzemień",
  "item.minecraft.porkchop": "surowa wieprzowina",
  "item.minecraft.cooked_porkchop": "pieczona wieprzowina",
  "item.minecraft.painting": "obraz",
  "item.minecraft.golden_apple": "złote jabłko",
  "item.minecraft.enchanted_golden_apple": "zaklęte złote jabłko",
  "block.minecraft.oak_sign": "dębowa tabliczka",
  "block.minecraft.spruce_sign": "świerkowa tabliczka",
  "block.minecraft.birch_sign": "brzozowa tabliczka",
  "block.minecraft.jungle_sign": "tropikalna tabliczka",
  "block.minecraft.acacia_sign": "akacjowa tabliczka",
  "block.minecraft.dark_oak_sign": "ciemnodębowa tabliczka",
  "block.minecraft.crimson_sign": "szkarłatna tabliczka",
  "block.minecraft.warped_sign": "spaczona tabliczka",
  "item.minecraft.bucket": "wiadro",
  "item.minecraft.water_bucket": "wiadro wody",
  "item.minecraft.lava_bucket": "wiadro lawy",
  "item.minecraft.minecart": "wagonik",
  "item.minecraft.saddle": "siodło",
  "item.minecraft.redstone": "sproszkowany redstone",
  "item.minecraft.snowball": "śnieżka",
  "item.minecraft.oak_boat": "dębowa łódka",
  "item.minecraft.leather": "skóra",
  "item.minecraft.milk_bucket": "wiadro mleka",
  "item.minecraft.pufferfish_bucket": "wiadro z rozdymką",
  "item.minecraft.salmon_bucket": "wiadro z łososiem",
  "item.minecraft.cod_bucket": "wiadro z dorszem",
  "item.minecraft.tropical_fish_bucket": "wiadro z tropikalną rybą",
  "item.minecraft.brick": "cegła",
  "item.minecraft.clay_ball": "kulka gliny",
  "block.minecraft.dried_kelp_block": "blok suszonych wodorostów",
  "item.minecraft.paper": "papier",
  "item.minecraft.book": "książka",
  "item.minecraft.slime_ball": "kula szlamu",
  "item.minecraft.chest_minecart": "wagonik ze skrzynią",
  "item.minecraft.furnace_minecart": "napędzany wagonik",
  "item.minecraft.egg": "jajko",
  "item.minecraft.compass": "kompas",
  "item.minecraft.fishing_rod": "wędka",
  "item.minecraft.clock": "zegar",
  "item.minecraft.glowstone_dust": "jasnopył",
  "item.minecraft.cod": "surowy dorsz",
  "item.minecraft.salmon": "surowy łosoś",
  "item.minecraft.tropical_fish": "ryba tropikalna",
  "item.minecraft.pufferfish": "rozdymka",
  "item.minecraft.cooked_cod": "pieczony dorsz",
  "item.minecraft.cooked_salmon": "pieczony łosoś",
  "item.minecraft.ink_sac": "torbiel z atramentem",
  "item.minecraft.red_dye": "czerwony barwnik",
  "item.minecraft.green_dye": "zielony barwnik",
  "item.minecraft.cocoa_beans": "ziarna kakaowe",
  "item.minecraft.lapis_lazuli": "lazuryt",
  "item.minecraft.purple_dye": "fioletowy barwnik",
  "item.minecraft.cyan_dye": "błękitny barwnik",
  "item.minecraft.light_gray_dye": "jasnoszary barwnik",
  "item.minecraft.gray_dye": "szary barwnik",
  "item.minecraft.pink_dye": "różowy barwnik",
  "item.minecraft.lime_dye": "jasnozielony barwnik",
  "item.minecraft.yellow_dye": "żółty barwnik",
  "item.minecraft.light_blue_dye": "jasnoniebieski barwnik",
  "item.minecraft.magenta_dye": "karmazynowy barwnik",
  "item.minecraft.orange_dye": "pomarańczowy barwnik",
  "item.minecraft.bone_meal": "mączka kostna",
  "item.minecraft.blue_dye": "niebieski barwnik",
  "item.minecraft.brown_dye": "brązowy barwnik",
  "item.minecraft.black_dye": "czarny barwnik",
  "item.minecraft.white_dye": "biały barwnik",
  "item.minecraft.bone": "kość",
  "item.minecraft.sugar": "cukier",
  "block.minecraft.cake": "ciasto",
  "block.minecraft.white_bed": "białe łóżko",
  "block.minecraft.orange_bed": "pomarańczowe łóżko",
  "block.minecraft.magenta_bed": "karmazynowe łóżko",
  "block.minecraft.light_blue_bed": "jasnoniebieskie łóżko",
  "block.minecraft.yellow_bed": "żółte łóżko",
  "block.minecraft.lime_bed": "jasnozielone łóżko",
  "block.minecraft.pink_bed": "różowe łóżko",
  "block.minecraft.gray_bed": "szare łóżko",
  "block.minecraft.light_gray_bed": "jasnoszare łóżko",
  "block.minecraft.cyan_bed": "błękitne łóżko",
  "block.minecraft.purple_bed": "fioletowe łóżko",
  "block.minecraft.blue_bed": "niebieskie łóżko",
  "block.minecraft.brown_bed": "brązowe łóżko",
  "block.minecraft.green_bed": "zielone łóżko",
  "block.minecraft.red_bed": "czerwone łóżko",
  "block.minecraft.black_bed": "czarne łóżko",
  "item.minecraft.cookie": "ciastko",
  "item.minecraft.filled_map": "mapa□#0",
  "item.minecraft.shears": "nożyce",
  "item.minecraft.melon_slice": "kawałek arbuza",
  "item.minecraft.dried_kelp": "suszony wodorost",
  "item.minecraft.pumpkin_seeds": "nasiona dyni",
  "item.minecraft.melon_seeds": "nasiona arbuza",
  "item.minecraft.beef": "surowa wołowina",
  "item.minecraft.cooked_beef": "pieczona wołowina",
  "item.minecraft.chicken": "surowy kurczak",
  "item.minecraft.cooked_chicken": "pieczony kurczak",
  "item.minecraft.rotten_flesh": "zgniłe mięso",
  "item.minecraft.ender_pearl": "enderperła",
  "item.minecraft.blaze_rod": "płomienna różdżka",
  "item.minecraft.ghast_tear": "łza ghasta",
  "item.minecraft.gold_nugget": "bryłka złota",
  "item.minecraft.nether_wart": "netherowa brodawka",
  "item.minecraft.potion": "niewykonalna mikstura□brak efektów",
  "item.minecraft.glass_bottle": "szklana butelka",
  "item.minecraft.spider_eye": "oko pająka",
  "item.minecraft.fermented_spider_eye": "sfermentowane oko pająka",
  "item.minecraft.blaze_powder": "płomienny proszek",
  "item.minecraft.magma_cream": "magmowy krem",
  "block.minecraft.brewing_stand": "statyw alchemiczny",
  "block.minecraft.cauldron": "kocioł",
  "item.minecraft.ender_eye": "oko endera",
  "item.minecraft.glistering_melon_slice": "kawałek lśniącego arbuza",
  "item.minecraft.bat_spawn_egg": "jajo przyzywające nietoperza",
  "item.minecraft.bee_spawn_egg": "jajo przyzywające pszczołę",
  "item.minecraft.blaze_spawn_egg": "jajo przyzywające płomyka",
  "item.minecraft.cat_spawn_egg": "jajo przyzywające kota",
  "item.minecraft.cave_spider_spawn_egg": "jajo przyzywające pająka jaskiniowego",
  "item.minecraft.chicken_spawn_egg": "jajo przyzywające kurę",
  "item.minecraft.cod_spawn_egg": "jajo przyzywające dorsza",
  "item.minecraft.cow_spawn_egg": "jajo przyzywające krowę",
  "item.minecraft.creeper_spawn_egg": "jajo przyzywające creepera",
  "item.minecraft.dolphin_spawn_egg": "jajo przyzywające delfina",
  "item.minecraft.donkey_spawn_egg": "jajo przyzywające osła",
  "item.minecraft.drowned_spawn_egg": "jajo przyzywające utopca",
  "item.minecraft.elder_guardian_spawn_egg": "jajo przyzywające prastrażnika",
  "item.minecraft.enderman_spawn_egg": "jajo przyzywające endermana",
  "item.minecraft.endermite_spawn_egg": "jajo przyzywające endermita",
  "item.minecraft.evoker_spawn_egg": "jajo przyzywające przywoływacza",
  "item.minecraft.fox_spawn_egg": "jajo przyzywające lisa",
  "item.minecraft.ghast_spawn_egg": "jajo przyzywające ghasta",
  "item.minecraft.guardian_spawn_egg": "jajo przyzywające strażnika",
  "item.minecraft.hoglin_spawn_egg": "jajo przyzywające hoglina",
  "item.minecraft.horse_spawn_egg": "jajo przyzywające konia",
  "item.minecraft.husk_spawn_egg": "jajo przyzywające posucha",
  "item.minecraft.llama_spawn_egg": "jajo przyzywające lamę",
  "item.minecraft.magma_cube_spawn_egg": "jajo przyzywające kostkę magmy",
  "item.minecraft.mooshroom_spawn_egg": "jajo przyzywające mooshrooma",
  "item.minecraft.mule_spawn_egg": "jajo przyzywające muła",
  "item.minecraft.ocelot_spawn_egg": "jajo przyzywające ocelota",
  "item.minecraft.panda_spawn_egg": "jajo przyzywające pandę",
  "item.minecraft.parrot_spawn_egg": "jajo przyzywające papugę",
  "item.minecraft.phantom_spawn_egg": "jajo przyzywające fantoma",
  "item.minecraft.pig_spawn_egg": "jajo przyzywające świnię",
  "item.minecraft.piglin_spawn_egg": "jajo przyzywające piglina",
  "item.minecraft.pillager_spawn_egg": "jajo przyzywające rozbójnika",
  "item.minecraft.polar_bear_spawn_egg": "jajo przyzywające niedźwiedzia polarnego",
  "item.minecraft.pufferfish_spawn_egg": "jajo przyzywające rozdymkę",
  "item.minecraft.rabbit_spawn_egg": "jajo przyzywające królika",
  "item.minecraft.ravager_spawn_egg": "jajo przyzywające dewastatora",
  "item.minecraft.salmon_spawn_egg": "jajo przyzywające łososia",
  "item.minecraft.sheep_spawn_egg": "jajo przyzywające owcę",
  "item.minecraft.shulker_spawn_egg": "jajo przyzywające shulkera",
  "item.minecraft.silverfish_spawn_egg": "jajo przyzywające rybika cukrowego",
  "item.minecraft.skeleton_spawn_egg": "jajo przyzywające szkieleta",
  "item.minecraft.skeleton_horse_spawn_egg": "jajo przyzywające konia-szkieleta",
  "item.minecraft.slime_spawn_egg": "jajo przyzywające szlama",
  "item.minecraft.spider_spawn_egg": "jajo przyzywające pająka",
  "item.minecraft.squid_spawn_egg": "jajo przyzywające kałamarnicę",
  "item.minecraft.stray_spawn_egg": "jajo przyzywające tułacza",
  "item.minecraft.strider_spawn_egg": "jajo przyzywające magmołaza",
  "item.minecraft.trader_llama_spawn_egg": "jajo przyzywające lamę handlarza",
  "item.minecraft.tropical_fish_spawn_egg": "jajo przyzywające rybę tropikalną",
  "item.minecraft.turtle_spawn_egg": "jajo przyzywające żółwia",
  "item.minecraft.vex_spawn_egg": "jajo przyzywające dręczyciela",
  "item.minecraft.villager_spawn_egg": "jajo przyzywające osadnika",
  "item.minecraft.vindicator_spawn_egg": "jajo przyzywające obrońcę",
  "item.minecraft.wandering_trader_spawn_egg": "jajo przyzywające wędrownego handlarza",
  "item.minecraft.witch_spawn_egg": "jajo przyzywające wiedźmę",
  "item.minecraft.wither_skeleton_spawn_egg": "jajo przyzywające witherowego szkieleta",
  "item.minecraft.wolf_spawn_egg": "jajo przyzywające wilka",
  "item.minecraft.zoglin_spawn_egg": "jajo przyzywające zoglina",
  "item.minecraft.zombie_spawn_egg": "jajo przyzywające zombie",
  "item.minecraft.zombie_horse_spawn_egg": "jajo przyzywające konia-zombie",
  "item.minecraft.zombie_villager_spawn_egg": "jajo przyzywające osadnika-zombie",
  "item.minecraft.zombified_piglin_spawn_egg": "jajo przyzywające zzombifikowanego piglina",
  "item.minecraft.experience_bottle": "zaklęta butelka",
  "item.minecraft.fire_charge": "ognista kula",
  "item.minecraft.writable_book": "książka z piórem",
  "item.minecraft.written_book": "zapisana książka",
  "item.minecraft.emerald": "szmaragd",
  "item.minecraft.item_frame": "ramka na przedmiot",
  "block.minecraft.flower_pot": "doniczka",
  "item.minecraft.carrot": "marchewka",
  "item.minecraft.potato": "ziemniak",
  "item.minecraft.baked_potato": "pieczony ziemniak",
  "item.minecraft.poisonous_potato": "trujący ziemniak",
  "item.minecraft.map": "pusta mapa",
  "item.minecraft.golden_carrot": "złota marchewka",
  "block.minecraft.skeleton_skull": "czaszka szkieleta",
  "block.minecraft.wither_skeleton_skull": "czaszka witherowego szkieleta",
  "block.minecraft.player_head": "głowa gracza",
  "block.minecraft.zombie_head": "głowa zombie",
  "block.minecraft.creeper_head": "głowa creepera",
  "block.minecraft.dragon_head": "głowa smoka",
  "item.minecraft.carrot_on_a_stick": "marchewka na patyku",
  "item.minecraft.warped_fungus_on_a_stick": "spaczony grzyb na patyku",
  "item.minecraft.nether_star": "netherowa gwiazda",
  "item.minecraft.pumpkin_pie": "placek dyniowy",
  "item.minecraft.firework_rocket": "fajerwerk",
  "item.minecraft.firework_star": "gwiazdka pirotechniczna",
  "item.minecraft.enchanted_book": "zaklęta książka",
  "item.minecraft.nether_brick": "netherowa cegła",
  "item.minecraft.quartz": "kwarc",
  "item.minecraft.tnt_minecart": "wagonik z tnt",
  "item.minecraft.hopper_minecart": "wagonik z lejem",
  "item.minecraft.prismarine_shard": "odłamek pryzmarynu",
  "item.minecraft.prismarine_crystals": "kryształy pryzmarynu",
  "item.minecraft.rabbit": "surowy królik",
  "item.minecraft.cooked_rabbit": "pieczony królik",
  "item.minecraft.rabbit_stew": "potrawka z królika",
  "item.minecraft.rabbit_foot": "królicza łapka",
  "item.minecraft.rabbit_hide": "królicza skóra",
  "item.minecraft.armor_stand": "stojak na zbroję",
  "item.minecraft.iron_horse_armor": "żelazna zbroja końska",
  "item.minecraft.golden_horse_armor": "złota zbroja końska",
  "item.minecraft.diamond_horse_armor": "diamentowa zbroja końska",
  "item.minecraft.leather_horse_armor": "skórzana zbroja końska",
  "item.minecraft.lead": "smycz",
  "item.minecraft.name_tag": "znacznik",
  "item.minecraft.command_block_minecart": "wagonik z blokiem poleceń",
  "item.minecraft.mutton": "surowa baranina",
  "item.minecraft.cooked_mutton": "pieczona baranina",
  "block.minecraft.white_banner": "biały sztandar",
  "block.minecraft.orange_banner": "pomarańczowy sztandar",
  "block.minecraft.magenta_banner": "karmazynowy sztandar",
  "block.minecraft.light_blue_banner": "jasnoniebieski sztandar",
  "block.minecraft.yellow_banner": "żółty sztandar",
  "block.minecraft.lime_banner": "jasnozielony sztandar",
  "block.minecraft.pink_banner": "różowy sztandar",
  "block.minecraft.gray_banner": "szary sztandar",
  "block.minecraft.light_gray_banner": "jasnoszary sztandar",
  "block.minecraft.cyan_banner": "błękitny sztandar",
  "block.minecraft.purple_banner": "fioletowy sztandar",
  "block.minecraft.blue_banner": "niebieski sztandar",
  "block.minecraft.brown_banner": "brązowy sztandar",
  "block.minecraft.green_banner": "zielony sztandar",
  "block.minecraft.red_banner": "czerwony sztandar",
  "block.minecraft.black_banner": "czarny sztandar",
  "item.minecraft.end_crystal": "kryształ endu",
  "item.minecraft.chorus_fruit": "owoc refrenusu",
  "item.minecraft.popped_chorus_fruit": "prażony owoc refrenusu",
  "item.minecraft.beetroot": "burak",
  "item.minecraft.beetroot_seeds": "nasiona buraka",
  "item.minecraft.beetroot_soup": "barszcz czerwony",
  "item.minecraft.dragon_breath": "oddech smoka",
  "item.minecraft.splash_potion": "miotana niewykonalna mikstura□brak efektów",
  "item.minecraft.spectral_arrow": "widmowa strzała",
  "item.minecraft.tipped_arrow": "niewykonalna strzała z miksturą□brak efektów",
  "item.minecraft.lingering_potion": "trwała niewykonalna mikstura□brak efektów",
  "item.minecraft.shield": "tarcza",
  "item.minecraft.elytra": "elytry",
  "item.minecraft.spruce_boat": "świerkowa łódka",
  "item.minecraft.birch_boat": "brzozowa łódka",
  "item.minecraft.jungle_boat": "tropikalna łódka",
  "item.minecraft.acacia_boat": "akacjowa łódka",
  "item.minecraft.dark_oak_boat": "ciemnodębowa łódka",
  "item.minecraft.totem_of_undying": "totem nieśmiertelności",
  "item.minecraft.shulker_shell": "skorupa shulkera",
  "item.minecraft.iron_nugget": "bryłka żelaza",
  "item.minecraft.knowledge_book": "księga wiedzy",
  "item.minecraft.debug_stick": "patyk debugujący",
  "item.minecraft.music_disc_13": "płyta muzyczna□c418 – 13",
  "item.minecraft.music_disc_cat": "płyta muzyczna□c418 – cat",
  "item.minecraft.music_disc_blocks": "płyta muzyczna□c418 – blocks",
  "item.minecraft.music_disc_chirp": "płyta muzyczna□c418 – chirp",
  "item.minecraft.music_disc_far": "płyta muzyczna□c418 – far",
  "item.minecraft.music_disc_mall": "płyta muzyczna□c418 – mall",
  "item.minecraft.music_disc_mellohi": "płyta muzyczna□c418 – mellohi",
  "item.minecraft.music_disc_stal": "płyta muzyczna□c418 – stal",
  "item.minecraft.music_disc_strad": "płyta muzyczna□c418 – strad",
  "item.minecraft.music_disc_ward": "płyta muzyczna□c418 – ward",
  "item.minecraft.music_disc_11": "płyta muzyczna□c418 – 11",
  "item.minecraft.music_disc_wait": "płyta muzyczna□c418 – wait",
  "item.minecraft.music_disc_pigstep": "płyta muzyczna□lena raine – pigstep",
  "item.minecraft.trident": "trójząb□□kiedy w głównej ręce:□+8 do obrażeń□-2.9 od szybkości ataku",
  "item.minecraft.phantom_membrane": "błona fantoma",
  "item.minecraft.nautilus_shell": "muszla łodzika",
  "item.minecraft.heart_of_the_sea": "serce oceanu",
  "item.minecraft.crossbow": "kusza",
  "item.minecraft.suspicious_stew": "podejrzana potrawka",
  "block.minecraft.loom": "krosno",
  "item.minecraft.flower_banner_pattern": "wzór sztandaru□wzór kwiatu",
  "item.minecraft.creeper_banner_pattern": "wzór sztandaru□wizerunek creepera",
  "item.minecraft.skull_banner_pattern": "wzór sztandaru□wzór czaszki",
  "item.minecraft.mojang_banner_pattern": "wzór sztandaru□coś",
  "item.minecraft.globe_banner_pattern": "wzór sztandaru□sześcian ziemski",
  "item.minecraft.piglin_banner_pattern": "wzór sztandaru□ryjek",
  "block.minecraft.composter": "kompostownik",
  "block.minecraft.barrel": "beczka",
  "block.minecraft.smoker": "wędzarka",
  "block.minecraft.blast_furnace": "piec hutniczy",
  "block.minecraft.cartography_table": "stół kartograficzny",
  "block.minecraft.fletching_table": "stół łuczarski",
  "block.minecraft.grindstone": "kamień szlifierski",
  "block.minecraft.lectern": "pulpit",
  "block.minecraft.smithing_table": "stół kowalski",
  "block.minecraft.stonecutter": "przecinarka",
  "block.minecraft.bell": "dzwon",
  "block.minecraft.lantern": "latarenka",
  "block.minecraft.soul_lantern": "latarenka dusz",
  "item.minecraft.sweet_berries": "słodkie jagody",
  "block.minecraft.campfire": "ognisko",
  "block.minecraft.soul_campfire": "ognisko dusz",
  "block.minecraft.shroomlight": "światłogrzyb",
  "item.minecraft.honeycomb": "plaster miodu",
  "block.minecraft.bee_nest": "gniazdo pszczół",
  "block.minecraft.beehive": "ul",
  "item.minecraft.honey_bottle": "butelka miodu",
  "block.minecraft.honey_block": "blok miodu",
  "block.minecraft.honeycomb_block": "blok plastra miodu",
  "block.minecraft.lodestone": "magnetyt",
  "block.minecraft.netherite_block": "blok netherytu",
  "block.minecraft.ancient_debris": "pradawne zgliszcza",
  "block.minecraft.target": "tarcza strzelecka",
  "block.minecraft.crying_obsidian": "płaczący obsydian",
  "block.minecraft.blackstone": "czernit",
  "block.minecraft.blackstone_slab": "czernitowa płyta",
  "block.minecraft.blackstone_stairs": "czernitowe schody",
  "block.minecraft.gilded_blackstone": "złocony czernit",
  "block.minecraft.polished_blackstone": "wypolerowany czernit",
  "block.minecraft.polished_blackstone_slab": "wypolerowana czernitowa płyta",
  "block.minecraft.polished_blackstone_stairs": "wypolerowane czernitowe schody",
  "block.minecraft.chiseled_polished_blackstone": "rzeźbiony wypolerowany czernit",
  "block.minecraft.polished_blackstone_bricks": "wypolerowane czernitowe cegły",
  "block.minecraft.polished_blackstone_brick_slab": "wypolerowana czernitowa ceglana płyta",
  "block.minecraft.polished_blackstone_brick_stairs": "wypolerowane czernitowe ceglane schody",
  "block.minecraft.cracked_polished_blackstone_bricks": "popękane wypolerowane czernitowe cegły",
  "block.minecraft.respawn_anchor": "kotwica odrodzenia",
}
export const pl_pl = items; 
